import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { popupcontext } from "../../context/Popupscontext";
import { filtrationcontext } from "../../context/Filtercontext";
import { useGetAllSubmittalsQuery } from "../../Redux/service/Submittals/Submittals";
import trans from "../../utils";
import { Tag } from "antd";
import { formatDateString } from "../../JsHelpers/DateFormat";
import Actions from "../antd/Table/Actions";
import BreadCrumb from "../Header/BreadCrumb";
import Loader from "../Helpers/Loader/Loader";
import SubmittalsHead from "./SubmittalsParts/SubmittalsHead";
import AntdTable from "../antd/Table/Table";
import SubmittalsForm from "./SubmittalsForm/SubmittalsForm";
import SubmittalsMobile from "./mobile/SubmittalsMobile";
import useIsMobile from "../../hooks/useIsMobile";

export default function Submittals() {
  const isMobile = useIsMobile();
  const {
    handleShow,
    setEdited,
    deleteItem,
    setDeleteItem,
    setReloadData,
    reloadData,
  } = useContext(popupcontext);
  const {
    limit,
    setLimit,
    setSort: SetSortFilter,
    searchQuery,
    setSearchQuery,
  } = useContext(filtrationcontext);
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState({
    by: "",
    order: "",
  });
  const [filter, setFilter] = useState({
    status: null,
  });
  const buildQueryString = (filterObj) => {
    const query = Object.entries(filterObj)
      .filter(
        ([_, value]) => value !== null && value !== "" && value !== undefined,
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    return query ? `?${query}` : "";
  };

  const queryString = buildQueryString(filter);
  const {
    data: SubmittalsData,
    isLoading,
    refetch,
  } = useGetAllSubmittalsQuery(
    {
      page: currentPage,
      limit: limit,
      search: searchQuery,
      sortby: sort.by,
      sortorder: sort.order,
      status: filter.status,
      queryString: queryString,
    },
    {
      skip: !currentPage || !limit,
    },
  );

  const statusColors = {
    PENDING_QA: `orange`,
    PENDING_CONSULTANT: `orange`,
    APPROVED: `green`,
    REJECTED: `red`,
    REVISION_REQUIRED: `purple`,
    RETURNED_TO_CONTRACTOR: `default`,
  };
  const SubmittalsCol = [
    {
      title: trans("Submittal Number"),
      dataIndex: "submittalNumber",
      fixed: "left",
      key: "submittalNumber",
      width: 200,
      sorter: true,
      render: (submittalNumber) => <span>{submittalNumber}</span>,
    },
    {
      title: trans("Type"),
      key: "type",
      dataIndex: "type",
      width: 150,
      sorter: true,
      render: (type) => <span>{type ? trans(type) : "- - - -"}</span>,
    },
    {
      title: trans("Project"),
      key: "project",
      dataIndex: "project",
      width: 150,
      sorter: true,
      render: (_, record) => (
        <span>{record?.project?.name ? record?.project?.name : "- - - -"}</span>
      ),
    },
    {
      title: trans("Discipline"),
      key: "discipline",
      dataIndex: "discipline",
      width: 150,
      sorter: true,
      render: (discipline) => <span>{trans(discipline)}</span>,
    },

    {
      title: trans("Status"),
      key: "status",
      dataIndex: "status",
      width: 150,
      sorter: true,
      render: (status) => {
        return (
          <Tag color={statusColors[status] || "default"}>{trans(status)}</Tag>
        );
      },
    },
    {
      title: trans("Review Date"),
      key: "targetReviewDate",
      sorter: true,
      dataIndex: "targetReviewDate",
      width: 200,
      render: (targetReviewDate) => (
        <span>{formatDateString(targetReviewDate)}</span>
      ),
    },
    {
      title: trans("Submitted By"),
      key: "submittedBy",
      width: 180,
      sorter: true,
      render: (_, record) => <span>{record?.submittedBy?.name}</span>,
    },
    {
      title: trans("Created At"),
      sorter: true,
      dataIndex: "createdAt",
      key: "createdAt",
      width: 200,
      render: (createdAt) => <span>{formatDateString(createdAt)}</span>,
    },
    {
      title: trans("Actions"),
      key: "actions",
      fixed: "right",
      width: 120,
      render: (_, record) => (
        <Actions submittalId={record.id} name={record.name} />
      ),
    },
  ];
  useEffect(() => {
    localStorage.setItem("page", currentPage);
  }, [currentPage]);
  useEffect(() => {
    if (reloadData) {
      refetch();
    }
    setReloadData(false);
  }, [reloadData]);
  useEffect(() => {
    return () => {
      SetSortFilter({ type: "", value: "" });
      setSearchQuery("");
    };
  }, [SetSortFilter, setSearchQuery]);
  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      setSort({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      setSort({
        by: "",
        order: "",
      });
    }
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);
  return (
    <>
      <Helmet>
        <title>Submittal</title>
        <meta name="description" content="IR" />
      </Helmet>
      {isMobile ? (
        <SubmittalsMobile />
      ) : (
        <>
          <BreadCrumb
            title={trans("Submittal")}
            add={trans("Add new Submittal")}
            onClick={() => handleShow("addForm")}
          />
          <SubmittalsHead setFilter={setFilter} />
          {isLoading ? (
            <>
              <div className="loader-container loader-table">
                <Loader />
              </div>
            </>
          ) : (
            <>
              <div className="bg-white-rounded-top table-parent mt-4">
                <AntdTable
                  columns={SubmittalsCol}
                  dataSource={SubmittalsData?.data || []}
                  loading={isLoading}
                  pageSize={limit}
                  totalItems={SubmittalsData?.totalResults || 0}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                  onLimitChange={(newLimit) => {
                    setLimit(newLimit);
                    setCurrentPage(1);
                  }}
                  onTableChange={handleTableChange}
                />
              </div>
            </>
          )}
        </>
      )}
      <SubmittalsForm />
    </>
  );
}
